import React from "react";

const Footer = () => {
    return (
        <div className="App-footer">Julie Wilson 2018</div>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js